// Copyright (c) Hamilton Manufacturing Corp.

import { HamQuest } from "../../../App";


const reducer = (state, action) => {
    switch (action.type) {
        case 'REHYDRATE_STATE':
            if (JSON.stringify(state) === JSON.stringify(action.payload)) return;
            return {
                // ...state,
                ...action.payload,
            };

        case 'ADD_STANDARD_CUSTOMER_INFO':
            return {
                ...state,
                customerCheckoutInformation: action.payload.checkoutInformation,
            };

        case 'SET_STYLE_CONFIG':
            return {
                ...state,
                styleConfig: { ...action.payload },
            };

        case 'STYLE_REFRESH':
            return {
                ...state,
                styleRefresh: state.styleRefresh + 1,
            };

        case 'SET_URL_KEY':
            const urlState = {
                ...state,
                url_key: action.payload,
            };
            return urlState;

        case 'SET_APP_KEY':
            return {
                ...state,
                app_key: action.payload,
            };

        case 'SET_CONFIG':
            return {
                ...state,
                site_config: {
                    ...action.payload
                },
                isLoading: false,
            };

        case 'SET_PROCESSOR':
            return {
                ...state,
                processor_settings: action.payload,
            };

        case 'SET_LOCATIONS':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    locations: action.payload,
                }
            };

        case 'SET_STATES':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    states: action.payload,
                }
            };

        // case 'SET_MOBILE_VIEW':
        //     return {
        //         ...state,
        //         mobileView: action.payload
        //     };

        case 'SET_THEME':
            return {
                ...state,
                dark_theme: action.payload
            };

        case 'SET_THEMES':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    themes: action.payload,
                }
            };

        case 'SET_LIGHT_THEME':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    lightTheme: action.payload,
                }
            };

        case 'SET_DARK_THEME':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    darkTheme: action.payload,
                }
            };

        case 'SET_HOME_CARDS':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    homeCards: action.payload,
                }
            };

        case 'SET_BUBBLES':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    bubbles: {
                        ...state.site_config.bubbles,
                        enabled: action.payload
                    },
                }
            };

        case 'SET_FONT_SIZE':
            return {
                ...state,
                site_config: {
                    ...state.site_config,
                    fontSize: action.payload,
                }
            };

        //USERS
        case 'SET_ACCESS_TOKEN':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    isLoggedIn: true,
                    ...action.payload,
                },
            };

        case 'SET_GUEST_LOGIN':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    isGuestUser: action.payload
                },
            };

        case 'SET_USER_LOCATION':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    location: action.payload
                },
            };

        case 'SET_ACCOUNT_INFO':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    account: action.payload,
                },
            };

        case 'SET_ACCOUNT_PAYMENT':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    payment: action.payload
                },
            };

        case 'CLEAR_ACTIVE_USER':
            HamQuest.clearHeaderKeys();
            return {
                ...state,
                cart: [],
                active_user: {
                    isLoggedIn: false,
                    isGuestUser: false,
                    account: {},
                    vehicle: null,
                    payment: null,
                    accessToken: null,
                    refreshToken: null,
                    washClub: null,
                    location: {
                        lat: null,
                        lng: null
                    },
                    notifications: {
                        unread: 0,
                        messages: []
                    },
                    pastGifts: [],
                    forcedLocation: null
                },
            };

        case 'SET_CONFIRMED_EMAIL':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    account: {
                        ...state.active_user.account,
                        emailConfirmed: action.payload
                    }
                },
            };

        case 'SET_UNREAD_NOTIFICATIONS':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    notifications: {
                        ...state.active_user.notifications,
                        unread: action.payload
                    }
                },
            };

        case 'SET_NOTIFICATIONS':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    notifications: {
                        ...state.active_user.notifications,
                        messages: action.payload
                    }
                },
            };

        case 'CLEAR_NOTIFICATIONS':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    notifications: {
                        unread: 0,
                        messages: state.active_user.notifications.messages.map(e => { return { ...e, seen: true } })
                    }
                },
            };

        case 'SET_WASH_CLUB':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    washClub: action.payload
                },
            };

        case 'SET_VEHICLE':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    vehicle: action.payload
                },
            };

        // user subscriptions
        case 'GET_USER_SUBSCRIPTION':
            if (!action.payload)
                return {
                    ...state,
                    subscription: {
                        isSubscribed: false,
                        isLoading: false
                    }
                }
            else
                return {
                    ...state,
                    subscription: {
                        ...action.payload,
                        isSubscribed: true,
                        isLoading: false
                    }
                }

        // user payment methods
        case 'GET_USER_PAYMENT_METHOD':
            if (!action.payload)
                return {
                    ...state,
                    paymentMethod: {
                        hasPaymentMethod: false,
                        isLoading: false
                    }
                }
            else
                return {
                    ...state,
                    paymentMethod: {
                        ...action.payload,
                        hasPaymentMethod: true,
                        isLoading: false
                    }
                }

        case 'SET_USER_WALLET':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    wallet: action.payload
                },
            };

        case 'ADD_GIFT_EMAIL':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    pastGifts: [...new Set([...state.active_user.pastGifts, action.payload])]
                },
            };
        case 'SET_FORCED_LOCATION':
            return {
                ...state,
                active_user: {
                    ...state.active_user,
                    forcedLocation: action.payload
                },
            };

        case 'SET_OFFLINE':
            return {
                ...state,
                isOffline: action.payload,
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: { ...state.error, ...action.payload },
            };

        case 'CLEAR_ERROR':
            return {
                ...state,
                error: { title: '', message: '' },
            };

        case 'SET_LOADING':
            return {
                ...state,
                isLoading: action.payload,
            };

        case 'SET_CART':
            return {
                ...state,
                cart: action.payload,
            };

        default:
            throw new Error();
    }
}

export default reducer;